import type { SVGProps } from 'react'
const SvgSyStopAndPlay = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M11.427 11.126 4.594 7.33A.4.4 0 0 0 4 7.68v8.64a.4.4 0 0 0 .594.35l6.833-3.796a1 1 0 0 0 0-1.748"
		/>
		<path d="M4.885 6.805c-.642-.357-1.485.14-1.485.875v8.64c0 .735.842 1.232 1.485.875l6.834-3.797c1.07-.594 1.07-2.202 0-2.796zM4.6 8.02l6.535 3.63c.301.168.301.532 0 .7L4.6 15.98zM16 6.4a.6.6 0 0 0-.6.6v10a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6V7a.6.6 0 0 0-.6-.6m4 0a.6.6 0 0 0-.6.6v10a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6V7a.6.6 0 0 0-.6-.6" />
	</svg>
)
export default SvgSyStopAndPlay
